import '../../scss/theme.scss';

import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';

import '../app';

import '../sections/header';

// Common a11y fixes
focusHash();
bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}
